import { domToBlob } from "modern-screenshot";

export const FEEDBACK_EXCLUDE_ATTR = "data-feedback-collector";
export const CLIENT_UI_REVIEW_EXCLUDE_ATTR = "data-client-ui-review";

const DEFAULT_MAX_HEIGHT = 8000;

export async function capturePageScreenshot(
  excludeAttr = FEEDBACK_EXCLUDE_ATTR,
  maxHeight = DEFAULT_MAX_HEIGHT
) {
  const root = document.documentElement;
  return domToBlob(root, {
    type: "image/jpeg",
    quality: 0.7,
    scale: 1,
    width: root.scrollWidth,
    height: Math.min(root.scrollHeight, maxHeight),
    backgroundColor: "#ffffff",
    filter: (node) => !(node instanceof Element && node.hasAttribute(excludeAttr)),
  });
}
